var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v(" "+_vm._s(_vm.item.title)+" ")]),_c('ul',{staticClass:"badges",class:{'height':!_vm.item.title}},_vm._l((_vm.item.badges),function(el,index){return _c('li',[_c('img',{attrs:{"src":el.value,"alt":el.value}}),_c('p',{domProps:{"innerHTML":_vm._s(el.text)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }